import { Button, Card, Divider, Flex, Modal, Skeleton, Space, Tag } from "antd";
import { IPayment } from "../../types/interfaces";
import { downloadFile } from "../../services/files";
import { useEffect, useState } from "react";
import useLoading from "../../hooks/useLoading";
import {
  PAYMENT_STATUS,
  PAYMENT_STATUS_COLOR,
} from "../../constants/constants";

interface Props {
  isModalOpen: boolean;
  handleApprove: (id: number) => void;
  handleReject: (id: number) => void;
  handleCancel: () => void;
  payment: IPayment | null;
  loading?: boolean;
  username: string;
}
function ReviewReceiptModal({
  isModalOpen,
  handleApprove,
  handleCancel,
  handleReject,
  loading,
  payment,
  username,
}: Props) {
  const [url, setUrl] = useState<string | undefined>("");
  const [receiptType, setReceiptType] = useState<"pdf" | "image">("pdf");

  useEffect(() => {
    if (payment?.receiptId) {
      const extension = payment.receiptId.split('.').pop()?.toLowerCase();
      const rt = extension === "pdf" ? "pdf" : "image";
      setReceiptType(rt);
      getUrl(payment?.receiptId, rt);
    }
  }, [payment?.receiptId]);

  const urlLoading = useLoading();

  const getUrl = async (path: string, receiptType: string) => {
    urlLoading.start();
    const uri = await downloadFile(path, receiptType);
    setUrl(uri);
    urlLoading.stop();
  };

  const items = [
    {
      key: "1",
      label: "Usuario",
      children: username,
    },
    {
      key: "2",
      label: "Fecha de pago",
      children: payment?.paymentDate,
    },
    {
      key: "3",
      label: "Fecha de emisión",
      children: payment?.dueDate,
    },
    {
      key: "4",
      label: "Monto",
      children: `$ ${payment?.amount}`,
    },
    {
      key: "5",
      label: "Estado",
      children: PAYMENT_STATUS[payment?.status || "processing"],
    },
  ];

  const buttons = [
    <Button key="back" onClick={handleCancel}>
      Cancelar
    </Button>,
  ];

  if (payment?.status === "processing") {
    buttons.unshift(
      <Button
        key="approve"
        id={"approve"}
        type="primary"
        onClick={() => handleApprove(payment?.id || 0)}
        loading={loading}
      >
        Aprobar
      </Button>,
      <Button
        key="reject"
        id={"reject"}
        className={"reject-button"}
        type={"default"}
        onClick={() => handleReject(payment?.id || 0)}
        loading={loading}
      >
        Rechazar
      </Button>,
    );
  }

  return (
    <Modal
      title={"Ultimo recibo"}
      open={isModalOpen}
      width={1000}
      closable={false}
      footer={[...buttons]}
      closeIcon={false}
      destroyOnClose
    >
      <Flex gap={12} wrap>
        {items.map((item) => (
          <Space key={item.key}>
            <strong
              style={{
                fontSize: "18px",
              }}
            >
              {item.label}:
            </strong>
            <p
              style={{
                fontSize: "18px",
              }}
            >
              {item.label === "Estado" ? (
                <Tag
                  color={PAYMENT_STATUS_COLOR[payment?.status || "processing"]}
                >
                  {PAYMENT_STATUS[payment?.status || "processing"]}
                </Tag>
              ) : (
                item.children
              )}
            </p>
          </Space>
        ))}
      </Flex>
      <Divider>Recibo</Divider>
      {url ? (
        <Card>
          {receiptType === "pdf" ? (
            <object
              type={"application/pdf"}
              data={url}
              width="100%"
              height="1000px"
            />
          ) : null}
          {receiptType === "image" ? (
            <img src={url} alt={"receipt"} style={{ width: "100%" }} />
          ) : null}
        </Card>
      ) : (
        <Card>
          <Skeleton active loading={loading} paragraph={{ rows: 4 }} />
        </Card>
      )}

      <Divider style={{ margin: "0" }} />
    </Modal>
  );
}

export default ReviewReceiptModal;
